export const FORM_INPUT_NAME = 'heroName'; export const FORM_INPUT_REFERRAL = 'heroReferral'; export const
FORM_INPUT_FREE_TRIAL = 'freeTrial'; export const MAX_HERO_NAME_LENGTH = 18;
